import apiInstance from "api";

export const ServicesApiService = {
  list: async (filters = {}) => {
    return await apiInstance.get(`/services`, { params: { ...filters } });
  },
  get: async (id) => {
    return await apiInstance.get(`/services/${id}`);
  },
  create: async (body) => {
    return await apiInstance.post(`/services`, body);
  },
  update: async (body) => {
    return await apiInstance.put(`/services`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/services/${id}`);
  },
  toggleStatus: async (body) => {
    return await apiInstance.put(`/services/status`, body);
  },
};
